import { render, staticRenderFns } from "./rollback-record-dialog.vue?vue&type=template&id=14b40473&scoped=true&"
import script from "./rollback-record-dialog.vue?vue&type=script&lang=js&"
export * from "./rollback-record-dialog.vue?vue&type=script&lang=js&"
import style0 from "./rollback-record-dialog.vue?vue&type=style&index=0&id=14b40473&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b40473",
  null
  
)

export default component.exports